{
    "Budō Lineage Tree": "武道の系譜",
    "Teachers" : "先生方",
    "Students": "弟子",
    "Rank": "順位",
    "Sources": "情報源",
    "Tree": "系譜",
    "Persons": "武道家",
    "Styles": "流儀",
    "All Styles": "すべての流儀",
    "Timeline": "年表",
    "A timeline of Budōka": "武道家の年表"
}
